module.exports = __webpack_public_path__ + "media/images/lb/508-7cef5d93b67d65e28cd2c2e2afc8dab8.svg";